<div class="meses">
  @for (m of meses; track m.mes) {
    <button
      class="mes-card"
      type="button"
      [class.selected]="mesSelecionado === m.mes"
      (click)="select(m.mes)"
    >
      <div class="mes-tag">{{ m.nomeCompleto }}</div>

      <div class="row">
        <span class="label">Total Gasto:</span>
        <span class="value">{{ formatUSD(m.total) }}</span>
      </div>
    </button>
  }
</div>
